import { type FC } from 'react';

import styles from './NotFoundPage.module.css';

export const NotFoundPage: FC = () => (
  <div className={styles.root}>
    <div className={styles.code} aria-hidden>
      404
    </div>
    <h1 className={styles.title}>Страница не найдена</h1>
  </div>
);
